import { z } from 'zod';

export const ShippingCourierValidation = z.object({
  clientNumber: z.string(),
  username: z.string(),
  password: z.string(),
});
